<template>
	<el-footer>
		<div class="footer">
			<div class="info">
				<div class="ul">
					<div class="ol">{{$t('nav.about')}}</div>
					<div class="li">ABOUT US</div>
					<div class="li" @click="$router.push({ path:'AboutUs/synopsis'})">{{$t('about.abCen')}}</div>
					<div class="li" @click="$router.push({ path:'AboutUs/expert'})">{{$t('about.zhjia')}}</div>
					<div class="li" @click="$router.push({ path:'AboutUs/quality'})">{{$t('about.zhl')}}</div>
					<div class="li" @click="$router.push({ path:'AboutUs/culture'})">{{$t('about.qiwen')}}</div>
				</div>
				<div class="ul">
					<div class="ol">{{$t('nav.yan')}}</div>
					<div class="li">Service platform</div>
					<div class="li" v-for="(val,index) in research" :key='index'>
						<span v-if="$i18n.locale == 'zh'" @click="$router.push({ path:'/service/cro?id='+val.id })">{{val.title}}</span>
						<span v-else-if="$i18n.locale == 'en'" @click="$router.push({ path:'/service/cro?id='+val.id })">{{val.y_title}}</span>
						<span v-else @click="$router.push({ path:'/service/cro?id='+val.id })">{{val.e_title}}</span>
					</div>
				</div>
				<div class="ul">
					<div class="ol">{{$t('nav.pro')}}</div>
					<div class="li">PRODUCTS CENTER</div>
					<div class="li" v-for="(val,index) in pro" :key='index'>
						<span v-if="$i18n.locale == 'zh'" @click="toProductDetail(val)">{{val.name}}</span>
						<span v-else-if="$i18n.locale == 'en'" @click="toProductDetail(val)">{{val.y_name}}</span>
						<span v-else @click="toProductDetail(val)">{{val.e_name}}</span>
					</div>
					<!-- <div class="li">医药中间体</div>
					<div class="li">催化剂</div>
					<div class="li">配体不对成合成</div> -->
				</div>
				<div class="ul">
					<div class="ol">{{$t('nav.new')}}</div>
					<div class="li">News Center</div>
					<div class="li" v-for="(val,index) in news" :key='index'>
						<!-- $router.go(0) -->
						<span v-if="$i18n.locale == 'zh'" @click="$router.push({ path:'/NewsCenter/news'+val.id });">{{val.name}}</span>
						<span v-else-if="$i18n.locale == 'en'" @click="$router.push({ path:'/NewsCenter/news'+val.id });">{{val.y_name}}</span>
						<span v-else @click="$router.push({ path:'/NewsCenter/news'+val.id });">{{val.e_name}}</span>
					</div>
				</div>
				<div class="ul">
					<div class="ol">{{$t('nav.jabout')}}</div>
					<div class="li">Join us</div>
					<div class="li" @click="$router.push({ path:'/about'})">{{$t('zpxi')}}</div>
				</div>
				<div class="ul">
					<div class="ol">{{$t('nav.contact')}}</div>
					<div class="li">CONTACT US</div>
					<div class="li" @click="$router.push({ path:'/contact'})">{{$t('ywzx')}}</div>
				</div>
			</div>
			<div class="span"></div>
			<div class="contact">
				<!-- 联系电话 -->
				<div class="title">{{$t('cont.lxdh')}}</div>
				<div class="phone">{{phone.phone}}</div>
				<!-- 地址 -->
				<div class="ul">
					<div class="ol">{{$t('dz')}}</div>
					<div class="li">OUR ADDRESS</div>
					<div class="li" style="width: 360px;" v-if="$i18n.locale == 'zh'" >{{phone.address}}</div>
					<div class="li" style="width: 360px;" v-else-if="$i18n.locale == 'en'">{{phone.y_address}}</div>
					<div class="li" style="width: 360px;" v-else>{{phone.e_address}}</div>

				</div>
			</div>
		</div>
		<div class="copyright">山西天宏达安医药科技有限公司 版权所有(C)2018 网络支持</div>
	</el-footer>
</template>

<script>
	export default {
		data() {
			return {
				userinfo: '',
				research:[],
				pro:[],
				news:[],
				phone:{},
			}
		},
		mounted() {
			this.getResearch()
			this.getType()
			this.getNews()
			this.getPhone()
		},
		methods: {
			// 去详情页面
			toProductDetail(val){
				var name = {
					name:val.name,
					y_name:val.y_name,
					e_name:val.e_name,
				};
				// if(this.$i18n.locale == 'zh'){
				//  	name = val.name
				// }else if($i18n.locale == 'en'){
				// 	name = val.y_name
				// }else{
				// 	name = val.e_name
				// }
				// this.$router.push({ path:'/product/productdetail?id='+val.id+'&name='+name })
				this.$router.push({ path:'/product/productdetail?id='+val.id+'&name='+JSON.stringify(name) })

			},
			//研发平台
			getResearch() {
				var that = this;
				this.$axios
					.post("/api/index/research", {
					
					})
					.then(function (ret) {
						if (ret.data.code == 0) {
							that.research = ret.data.data.research;
						} else {
							that.$fail(ret.data.msg);
						}
					}
				);
			},
			getType() {
				var that = this;
				this.$axios
					.post("/api/index/type", {
					})
					.then(function (ret) {
						if (ret.data.code == 0) {
							that.pro = ret.data.data.type;
						} else {
							that.$fail(ret.data.msg);
						}
					}
				);
			},
			getNews() {
				var that = this;
				this.$axios
					.post("/api/index/news_type", {
					})
					.then(function (ret) {
						if (ret.data.code == 0) {
							that.news = ret.data.data.news_type;
						} else {
							that.$fail(ret.data.msg);
						}
					}
				);
			},
			getPhone() {
				var that = this;
				this.$axios
					.post("/api/index/down_phone", {
					})
					.then(function (ret) {
						if (ret.data.code == 0) {
							that.phone = ret.data.data;
						} else {
							that.$fail(ret.data.msg);
						}
					}
				);
			},
		}
		

	}
</script>

<style lang="scss" scoped>
	.el-footer {
		width: 100%;
		height: 300px !important;
		padding:40px 0;
		background-color: #222222;
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #fff;
		.footer{
			display: flex;
			align-items: flex-start;
			justify-content: space-between;
			width: 1500px;
			.info{
				display: flex;
				align-items: flex-start;
				justify-content: space-between;
				width: 1000px;
			}
			.ul{
				display: flex;
				flex-direction: column;
				.ol{
					font-size: 16px;
					margin-bottom: 5px;
				}
				.li{
					font-size: 12px;
					margin-bottom: 20px;
					cursor: pointer;
				}
			}
			.span{
				width: 4px;
				height: 120px;
				background: #999999;
			}
			.contact{
				.title{
					font-size: 16px;
					margin-bottom: 10px;
				}
				.phone{
					font-size: 24px;
					font-weight: bold;
					margin-bottom:30px;
				}
			}
		}
		.copyright{
			font-size: 12px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/common/navFooter.vue